import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TurmaDisciplinaProfessorProfileInfo from './TurmaDisciplinaProfessorProfileInfo';

export default function TurmaDisciplinaProfessorProfile({ tdp, onTdpSelected }) {
    const handleTrocaTdp = useCallback(() => {
        onTdpSelected(null);
    }, [onTdpSelected]);

    return (
        <Card
            variant="outlined"
            sx={{
                width: '100%',
                maxWidth: 480,
                mx: 'auto',
                borderRadius: 2,
                boxShadow: 1,
                transition: 'box-shadow 0.2s ease-in-out',
                '&:hover': {
                    boxShadow: 3,
                },
            }}
        >
            <CardContent>
                <TurmaDisciplinaProfessorProfileInfo tdp={tdp} />
            </CardContent>

            <CardActions sx={{ px: 2, pb: 2 }}>
                <Button
                    onClick={handleTrocaTdp}
                    size="small"
                    color="secondary"
                    variant="contained"
                    startIcon={<SwapHorizIcon />}
                    fullWidth
                    aria-label="Trocar turma ou disciplina"
                >
                    Trocar Turma/Disciplina
                </Button>
            </CardActions>
        </Card>
    );
}

TurmaDisciplinaProfessorProfile.propTypes = {
    tdp: PropTypes.object.isRequired,
    onTdpSelected: PropTypes.func.isRequired,
};